import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, IconButton, Grid, Tooltip, Dialog, TextField } from '@material-ui/core'
import { Card, Container, Row, Col } from 'react-bootstrap'
import Badge from 'react-bootstrap/Badge'
// import CircularProgress from '@material-ui/core/CircularProgress'
import LinearProgress from '@material-ui/core/LinearProgress'
// import InputLabel from '@material-ui/core/InputLabel'
import Autocomplete from '@material-ui/lab/Autocomplete'

import * as actions from '../actions'
import { TablaComunicacionesView } from '../components/TablaComunicacionesView'
import DialogoComunicacionAdd from '../components/DialogoComunicacionAdd'
import CaratulaSaveStatus from './CaratulaSaveStatus'

import { INTERVALO_CORTO, INTERVALO } from '../../../config/settings'
import { ToastContainer } from 'react-toastify'
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// solid icons
import { faShip, faCheck, faCogs, faCheckCircle, faCog } from '@fortawesome/free-solid-svg-icons'
import FilterListIcon from '@material-ui/icons/FilterList'
import ReplayIcon from '@material-ui/icons/Replay'
import Fab from '@material-ui/core/Fab'
import HelpOutlineIcon from '@material-ui/icons/HelpOutline'
import LensIcon from '@material-ui/icons/Lens'
import UpdateIcon from '@material-ui/icons/Update'
import { COLORES } from '../../../config/colores'
import { saveAs } from 'file-saver'
import moment from 'moment'

library.add(faShip, faCheck, faCogs, faCheckCircle, faCog)

const savePdf = (url, filename) => {
  saveAs(url, filename)
}
class TablaComunicaciones extends Component {
  constructor (props) {
    super(props)
    this.state = { filtroExportador: null }
    this.state = { filtroExportadorRazonSocial: null }
    this.state = { ultimaActualizacion: new Date() }
  }

  componentDidMount () {
    this.props.actualizarDatosCaratulasInactivasParaMuiTable()
    this.props.actualizarDatosCaratulasActivasParaMuiTable()
    this.props.actualizarDatosCaratulasFinalizadasParaMuiTable()
    this.props.actualizarFiltrosExportadores()
    this.props.actualizarEstadosCaratulas()
    this.interval = setInterval(() => {
      this.props.actualizarEstadosCaratulas()
      this.setState({ ultimaActualizacion: new Date() })
      console.log('Ejecutando actualizacion de datos...')
    }, INTERVALO * 2)
  }

  componentWillUnmount () {
    clearInterval(this.interval)
  }

  render () {
    const {
      openAddCaratula,
      codigoAduana,
      mensajeAduana,
      idAduana,
      totalInactivas,
      totalActivas,
      totalFinalizadas,
      isRequestingSoap,
      status,
      filtroExportador,
      filtroExportadorRazonSocial,
      caratulasConEstado
    } = this.props

    const handleCloseAddCaratula = () => {
      this.props.setOpenDialog(false)
    }

    const handleSubmit = async () => {
      this.props.submitUpdateCaratula()
    }

    const handleConfirmStatus = () => {
      this.props.closeModal()
    }

    const changeExportador = async (value) => {
      console.log('exportador', value)
      if (value !== null) {
        this.setState({ filtroExportador: value.exportador })
        this.setState({ filtroExportadorRazonSocial: value.razonSocial })
      }
    }
    const { exportadores } = this.props

    const aceptar = async () => { 
      if (this.state.filtroExportador !== null) {
        this.props.actualizarEstadoFiltroExportadores(this.state.filtroExportador, this.state.filtroExportadorRazonSocial)
      }
    }

    const reset = async () => { 
      this.props.resetEstadoFiltroExportadores()
    }

    return (
      <div>
        <h3>Comunicación de Embarque</h3>
        <br />
        <ToastContainer autoClose={INTERVALO_CORTO} />
        {(isRequestingSoap) && <div className='circular-progress-consulta-soap'>
          {/* <CircularProgress thickness='5' size='5rem' style={{ margin: '0 auto' }} /> */}
          <LinearProgress style={{ width: '100%' }} />
        </div>}
        <CaratulaSaveStatus
          codigo={codigoAduana}
          onSubmit={handleConfirmStatus}
          mensaje={mensajeAduana}
          id={idAduana}
          status={status}
        />
        <Dialog
          open={openAddCaratula}
          onClose={handleCloseAddCaratula}
          fullWidth
          maxWidth='md'>
          <DialogoComunicacionAdd handleClose={handleCloseAddCaratula} handleSubmit={handleSubmit} />
        </Dialog>
        <div style={{ paddingLeft: '15px', paddingRight: '15px' }}>
          <Container fluid >
            <Row>
              <Col md={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='shadow bg-white rounded' text='dark' >
                  <Card.Body >
                    <Card.Title style={{ fontSize: '1.2em' }}>Carátulas Inactivas</Card.Title>
                    <Row>
                      <Col md={4}>
                        <FontAwesomeIcon icon='ship' size='5x' style={{ 'animation-iteration-count': '2' }} shake/>
                      </Col>
                      <Col md={6}>
                        <Card.Text style={{ fontSize: '4em', fontWeight: 'bold' }}>
                          {totalInactivas}
                        </Card.Text>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='shadow bg-white rounded' text='dark' >
                  <Card.Body >
                    <Card.Title style={{ fontSize: '1.2em' }}>Carátulas Activas</Card.Title>
                    <Row>
                      <Col md={4}>
                        <FontAwesomeIcon icon='cog' size='5x' style={{ 'animationDuration': '10s' }} spin />
                      </Col>
                      <Col md={6}>
                        <Card.Text style={{ fontSize: '4em', fontWeight: 'bold' }}>
                          {totalActivas}
                        </Card.Text>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='shadow bg-white rounded' text='dark' >
                  <Card.Body >
                    <Card.Title style={{ fontSize: '1.2em' }}>Carátulas Finalizadas</Card.Title>
                    <Row>
                      <Col md={4}>
                        <FontAwesomeIcon icon='check-circle' size='5x' style={{ 'animation-iteration-count': '2' }} shake />
                      </Col>
                      <Col md={6}>
                        <Card.Text style={{ fontSize: '4em', fontWeight: 'bold' }}>
                          {totalFinalizadas}
                        </Card.Text>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col md={2} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='shadow bg-white rounded' text='dark' >
                  <Card.Body >
                    <Card.Title style={{ fontSize: '1.2em' }}>Buques Autorizados</Card.Title>
                    <Row>
                      <Col md={12}>
                        <Card.Text style={{ fontSize: '0.9em', textAlign: 'left', fontWeight: 'bold' }}>
                          {(caratulasConEstado && caratulasConEstado.length !== 0) ? (
                            caratulasConEstado.map((caratula) => (
                              <Tooltip title={caratula.estadoBuqueEnAduana} placement="left-start">
                                <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-end' }}>
                                  <Col md={1}>
                                    <LensIcon style={{ color: (caratula.estadoBuqueEnAduana === 'AUTORIZADO') ? COLORES.green.light : COLORES.red.light }}/>
                                  </Col>
                                  <Col md={11}>
                                      {caratula.nombreBuque}
                                  </Col>
                                </div>
                              </Tooltip>
                            ))
                          ) : <LinearProgress style={{ width: '100%' }} /> }
                        </Card.Text>
                      </Col>
                    </Row>
                  </Card.Body>
                  <Card.Footer>
                    <Tooltip title={"Actualizar"} placement="top">
                      <div style={{ display: 'flex', justifyContent: 'flex-end' }}> 
                        <Col md={1}>
                          <IconButton
                            onClick={() => {
                              this.setState({ ultimaActualizacion: new Date() })
                              this.props.actualizarEstadosCaratulas()
                            }}
                            style={{ padding: 0 }}
                          >
                            <UpdateIcon style={{ color: COLORES.blue.light }} size="small" />
                          </IconButton>
                        </Col>
                        <Col md={11}>
                          <small className="text-muted">
                            Actualizado: {moment(this.state.ultimaActualizacion).format('DD-MM-YYYY HH:mm')}
                          </small>
                        </Col>
                      </div>
                    </Tooltip>
                  </Card.Footer>
                </Card>
              </Col>
              <Col md={4} style={{ paddingLeft: '10px', paddingRight: '10px' }}>
                <Card className='shadow bg-white rounded' 
                  onContextMenu={e => e.preventDefault()}>
                  <Card.Body >
                    <Card.Title 
                      style={{ textAlign: 'center', justifyContent: 'center', fontSize: '1em' }}><strong>Filtro por Exportador</strong>
                    </Card.Title>
                    <Row className='d-flex justify-content-start'>
                      <Grid container item spacing={2} justify='flex-end'>
                        <Grid container spacing={2} item>
                          <Grid item xs={12} sm={12}>
                            {/* <InputLabel id='exp-select' style={{ fontSize: '14px', color: '#000' }}>Exportador</InputLabel> */}
                            <Autocomplete
                              autoHighlight
                              id='exp-select'
                              name='exportador'
                              size='small'
                              options={exportadores}
                              //disabled={onlyView}
                              //defaultValue={exportador || null}
                              getOptionLabel={(option) => `${option.razonSocial} (${option.exportador})`}
                              onChange={(event, value) => changeExportador(value)}
                              renderInput={(params) => <TextField {...params} variant='outlined' />}
                            />
                          </Grid>
                        </Grid>
                        <Grid item xs='auto'>
                          <Button
                            color='primary'
                            variant='contained'
                            size='small'
                            startIcon={<FilterListIcon />}
                            //disabled={isSubmitting || !isValid}
                            //type='submit'>
                            onClick={() => {
                              aceptar()
                            }}>
                            Filtrar
                          </Button>
                        </Grid>
                        <Grid item xs='auto'>
                          <Button
                            color='primary'
                            variant='contained'
                            size='small'
                            startIcon={<ReplayIcon />}
                            onClick={() => {
                              reset()
                            }}>
                            Restablecer
                          </Button>
                        </Grid>
                      </Grid>
                    </Row>
                    <br />
                    <Row className='d-flex align-items-end justify-content-center'>
                      {(filtroExportador !== null) && <h6><Badge variant='secondary'>{filtroExportadorRazonSocial}</Badge></h6>}
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
          <TablaComunicacionesView 
            cambiarEstadoTablas = {this.props.cambiarEstadoTablas}
            actualizarFiltrosExportadores = {this.props.actualizarFiltrosExportadores}  
          />
        </div>
        <div>
          <Tooltip title={'Descargar Manual de Ayuda'}>
            <Fab color='primary' aria-label='Ayuda' size='medium'
              onClick={() => savePdf(`${process.env.REACT_APP_PDF_URL}Manual_Comunicacion_de_Embarque.pdf`, 'Manual_Comunicacion_de_Embarque.pdf')}
            >
              <HelpOutlineIcon />
            </Fab>
          </Tooltip>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    openAddCaratula: state.comunicacionEmbarque.openAddCaratula,
    status: state.comunicacionEmbarque.status,
    codigoAduana: state.comunicacionEmbarque.codigoAduana,
    mensajeAduana: state.comunicacionEmbarque.mensajeAduana,
    idAduana: state.comunicacionEmbarque.idAduana,
    totalInactivas: state.comunicacionEmbarque.totalInactivas,
    totalActivas: state.comunicacionEmbarque.totalActivas,
    totalFinalizadas: state.comunicacionEmbarque.totalFinalizadas,
    isRequestingSoap: state.comunicacionEmbarque.isRequestingSoap,
    exportadores: state.comunicacionEmbarque.exportadores,
    filtroExportador: state.comunicacionEmbarque.filtroExportador,
    filtroExportadorRazonSocial: state.comunicacionEmbarque.filtroExportadorRazonSocial,
    caratulasConEstado: state.comunicacionEmbarque.caratulasConEstado
  }
}

const withRedux = connect(mapStateToProps, actions)

export default withRedux(TablaComunicaciones)
